import ActionDropdown from "../../ActionDropdown";
import TableCheck from "../TableCheck";
import RenderStatus from "../../RenderStatus";
import DateFormatter from "../../DateFormatter";
import { dateFine } from "../../../util/Utilities";
import { formatDate, safeFormatCLP } from "../../../util/format";
import { ProgressBar } from "react-bootstrap";

import profile from "../../../images/profile.png";

const getTypeText = (typeString) => {
    if (!typeString || typeString === '--') return <span className="text-muted">--</span>;

    const lower = String(typeString).toLowerCase();

    let textClass = "text-secondary";
    let customStyle = {};

    if (lower.includes("mensual") || lower.includes("monthly")) {
        textClass = "text-success";
    } else if (lower.includes("extraordinario") || lower.includes("extraordinary")) {
        textClass = "text-primary";
    } else if (lower.includes("manual")) {
        textClass = "text-warning";
        customStyle = { color: '#d97706' };
    }

    return (
        <span
            className={`fw-bold ${textClass} text-truncate d-inline-block`}
            style={{ maxWidth: '140px', ...customStyle }}
            title={typeString}
        >
            {typeString}
        </span>
    );
};

const OrdersColumns = [
    {
        Label: TableCheck,
        Component: TableCheck

    },
    {
        Label: () => <div className="text-start" style={{ textAlign: 'left' }}>ID / Solicitante / Fecha</div>,
        Component: ({ value }) => (
            <div className="d-flex align-items-center text-start" style={{ textAlign: 'left' }}>
                <img
                    src={value?.user_image_path || value?.image_path || profile}
                    alt={value?.user_name || 'Solicitante'}
                    className="rounded-circle me-3"
                    style={{ width: '42px', height: '42px', objectFit: 'cover', flexShrink: 0 }}
                    onError={(e) => { e.target.onerror = null; e.target.src = profile; }}
                />
                <div className="d-flex flex-column align-items-start text-start" style={{ minWidth: 0, textAlign: 'left' }}>
                    <span className="text-primary fw-bold text-start" style={{ fontSize: '0.8rem', textAlign: 'left' }}>
                        #{value?.id}
                    </span>
                    <span
                        className="fw-semibold text-truncate text-start d-block"
                        style={{ fontSize: '0.9rem', lineHeight: '1.2', textAlign: 'left', maxWidth: '160px' }}
                        title={value?.user_name || ''}
                    >
                        {value?.user_name || '--'}
                    </span>
                    <small className="text-muted text-start" style={{ fontSize: '0.78rem', textAlign: 'left' }}>
                        {value?.created_at || '--'}
                    </small>
                </div>
            </div>
        )
    },
    {
        Label: () => <div className="text-start" style={{ textAlign: 'left' }}>Tipo / Servicio</div>,
        Component: ({ value }) => (
            <div className="d-flex flex-column text-start" style={{ textAlign: 'left', minWidth: 0 }}>
                <div className="d-flex align-items-center mb-1" style={{ minWidth: 0 }}>
                    <small className="text-muted flex-shrink-0 me-1">Tipo:</small>
                    {getTypeText(value?.type)}
                </div>
                <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
                    <small className="text-muted flex-shrink-0 me-1">Servicio:</small>
                    <span
                        className="fw-semibold text-truncate d-inline-block"
                        style={{ maxWidth: '140px' }}
                        title={value?.service_name || ''}
                    >
                        {value?.service_name || '--'}
                    </span>
                </div>
            </div>
        )
    },
    {
        Label: () => <div className="text-start" style={{ textAlign: 'left' }}>Aprobador / Adquisiciones</div>,
        Component: ({ value }) => (
            <div className="d-flex flex-column text-start" style={{ textAlign: 'left', minWidth: 0 }}>
                <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
                    <small className="text-muted flex-shrink-0 me-1">Aprobador:</small>
                    <span
                        className="fw-semibold text-truncate d-inline-block"
                        style={{ maxWidth: '140px' }}
                        title={value?.approver || ''}
                    >
                        {value?.approver || '--'}
                    </span>
                </div>
                <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
                    <small className="text-muted flex-shrink-0 me-1">Enc. Adq:</small>
                    <span
                        className="fw-semibold text-truncate d-inline-block"
                        style={{ maxWidth: '140px' }}
                        title={value?.acquisition_user || ''}
                    >
                        {value?.acquisition_user || '--'}
                    </span>
                </div>
            </div>
        )
    },
    {
        Label: () => 'Monto',
        Component: ({ value }) => safeFormatCLP(Number(value?.total))
    },
    {
        Label: () => 'Estatus',
        Component: ({ value }) => (
            <>
                <div style={{ display: 'flex', width: 'fit-content', alignItems: 'center', justifyContent: 'space-evenly', textTransform: 'capitalize' }}>
                    {value?.status_name}
                    <div
                        style={{
                            height: '10px',
                            width: '10px',
                            borderRadius: '100%',
                            background: value?.status_color
                        }}
                    />
                </div>
                <div className="d-flex align-items-center" style={{ minWidth: '100%' }}>
                    <ProgressBar
                        now={value?.progress}
                        variant={value?.status_variant_color}
                        className="my-3"
                        style={{ width: '60%' }}
                    />
                    <span style={{ marginLeft: '10px' }}>
                        {value?.progress}%
                    </span>
                </div>
            </>
        )
    },
    {
        Label: () => <div className="text-start" style={{ textAlign: 'left' }}>Aprobación / Envío</div>,
        Component: ({ value }) => (
            <div className="d-flex flex-column text-start" style={{ textAlign: 'left' }}>
                <div>
                    <small className="text-muted">Aprobación: </small>
                    <span className="fw-semibold">{value?.approved_at || '--'}</span>
                </div>
                <div>
                    <small className="text-muted">Envío: </small>
                    <span className="fw-semibold">{value?.sent_at || '--'}</span>
                </div>
            </div>
        )
    },
    {
        Label: () => 'Acciones',
        Component: ActionDropdown
    }
];

export default OrdersColumns;

